import authenticationRouter from './router/authenticationRouter'
import authenticationStore from './store/authentication.store'

const AuthenticationModule = {
    install (router, store) {
        // apply router
        router.addRoutes(authenticationRouter)
        // store
        store.registerModule('auth', authenticationStore)
    }
}

export default AuthenticationModule
